/** Custom code added - Javascript to handle Pairs well with section 
* - allows for user to add accessories to cart along with main product 
* or to click accessory to open a model to only add accessory to cart from main product page 
* - created on Aug 4, 2026 
**/
(function () {
  'use strict';

  let MAIN_FORM_SELECTOR = '.js-product-form'; 
  let MAIN_SUBMIT_BTN_SELECTOR = '[name="add"]'; 
  let VARIANT_INPUT_SELECTOR = 'input[name="id"], select[name="id"]';
  let QUANTITY_INPUT_SELECTOR = 'input[name="quantity"]';

  let moneyFormat = window.theme && window.theme.moneyFormat ? window.theme.moneyFormat : null;

  function formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function' && moneyFormat) {
      return Shopify.formatMoney(cents, moneyFormat);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    let root = document.querySelector('[data-pairs-well]');
    if (!root) {
      console.warn('[pairs-well-with] No [data-pairs-well] block found on this page.');
      return;
    }

    let modal = document.getElementById('pairs-well-modal');
    if (!modal) {
      console.warn('[pairs-well-with] Modal element #pairs-well-modal not found.');
      return;
    }

    let items = root.querySelectorAll('[data-pairs-well-item]');
    if (!items.length) {
      console.warn('[pairs-well-with] No [data-pairs-well-item] cards found inside the block.');
    }

    items.forEach(function (item, i) {
        let jsonEl;
      try {
        jsonEl = item.querySelector('[data-pairs-well-json]');
        if (!jsonEl) {
          console.error('[pairs-well-with] Item ' + i + ' has no JSON data script tag.');
          return;
        }

        let data = JSON.parse(jsonEl.textContent);

        let trigger = item.querySelector('[data-pairs-well-trigger]');
        if (!trigger) {
          console.error('[pairs-well-with] Item ' + i + ' has no trigger button.');
          return;
        }
        trigger.addEventListener('click', function () {
          openModal(modal, data);
        });

        trigger.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
            e.preventDefault();
            openModal(modal, data);
          }
        });

        buildInlineVariantSelect(item, data);
      } catch (err) {
        console.error('[pairs-well-with] Failed to initialize item ' + i + ':', err, jsonEl ? jsonEl.textContent : null);
      }
    });

    modal.querySelector('[data-pairs-well-close]').addEventListener('click', function () {
      modal.close();
    });

    setupCarousel(root);

    modal.addEventListener('click', function (e) {
      if (e.target === modal) modal.close();
    });

    // Hook the main product's add-to-cart form
    let mainForm = document.querySelector(MAIN_FORM_SELECTOR);
    if (mainForm) {
      document.addEventListener(
        'submit',
        function (e) {
          if (e.target !== mainForm) return;

          let checked = root.querySelectorAll('[data-pairs-well-checkbox]:checked');
          if (!checked.length) return;

          e.preventDefault();
          e.stopPropagation(); // keeps this from ever reaching product-form's own submit listener

          let submitControl = mainForm.querySelector(MAIN_SUBMIT_BTN_SELECTOR);
          performBundledAdd(mainForm, root, submitControl);
        },
        { capture: true }
      );
    } else {
      console.warn('[pairs-well-with] Could not find main product form with selector "' + MAIN_FORM_SELECTOR + '". Checkbox bundling will not work until this is fixed. See integration-notes.md.');
    }
  }

  // ---------------------------------------------------------------
  // Modal: open + populate with variant picker
  // ---------------------------------------------------------------
  function openModal(modal, data) {
    modal.dataset.productId = data.id;

    let img = modal.querySelector('[data-pairs-well-modal-image]');
    let title = modal.querySelector('[data-pairs-well-modal-title]');
    let price = modal.querySelector('[data-pairs-well-modal-price]');
    let descriptionEl = modal.querySelector('[data-pairs-well-modal-description]');
    let optionsWrap = modal.querySelector('[data-pairs-well-modal-options]');
    let addBtn = modal.querySelector('[data-pairs-well-modal-add]');
    let message = modal.querySelector('[data-pairs-well-modal-message]');

    title.textContent = data.title;
    message.textContent = '';
    optionsWrap.innerHTML = '';
    descriptionEl.innerHTML = data.description || '';

    function findVariantById(id) {
      return data.variants.find(function (v) {
        return String(v.id) === String(id);
      });
    }

    let hasPaintedOnce = false;

    function updateForVariant(variant) {
      if (!variant) {
        addBtn.disabled = true;
        addBtn.querySelector('[data-pairs-well-modal-add-label]').textContent = 'Unavailable';
        price.textContent = '';
        return;
      }

      if (!hasPaintedOnce || !isConnectedListingVariant(data, variant)) {
        img.src = variant.featured_image || data.featured_image || '';
      }
      hasPaintedOnce = true;

      img.alt = data.title;
      price.textContent = variant.compare_at_price && variant.compare_at_price > variant.price
        ? formatMoney(variant.compare_at_price) + ' ' + formatMoney(variant.price)
        : formatMoney(variant.price);
      addBtn.disabled = !variant.available;
      addBtn.querySelector('[data-pairs-well-modal-add-label]').textContent = variant.available ? 'Add to cart' : 'Sold out';
      modal.dataset.variantId = variant.id;

      resolveConnectedProductImage(data, variant, function (imgUrl) {
        if (String(modal.dataset.variantId) === String(variant.id)) {
          img.src = imgUrl;
        }
      });
    }

    let hasMultipleVariants = data.variants && data.variants.length > 1;
    let defaultVariant = data.variants.find(function (v) { return v.available; }) || data.variants[0];

    // Combined listings are always effectively a color/style choice, and any
    // product with a real option literally named "Color" gets swatches too.
    // Everything else keeps the dropdown.
    let hasColorOption = (data.options || []).some(function (opt) {
      return /color/i.test(opt.name);
    });
    let useSwatches = hasMultipleVariants && (data.is_combined_listing || hasColorOption);

    if (useSwatches) {
      let matchedColorOption = (data.options || []).find(function (opt) {
        return /color/i.test(opt.name);
      });
      let colorOptionLabel = matchedColorOption ? matchedColorOption.name : 'Color';

      let swatchLabel = document.createElement('p');
      swatchLabel.className = 'pairs-well-modal__swatch-label';
      swatchLabel.textContent = colorOptionLabel + ': ' + defaultVariant.title;
      optionsWrap.appendChild(swatchLabel);

      let swatchWrap = document.createElement('div');
      swatchWrap.className = 'pairs-well-modal__swatches';
      swatchWrap.setAttribute('role', 'listbox');
      swatchWrap.setAttribute('aria-label', data.title + ' options');

      data.variants.forEach(function (variant) {
        let swatch = document.createElement('button');
        swatch.type = 'button';
        swatch.className = 'pairs-well-modal__swatch';
        swatch.setAttribute('role', 'option');
        swatch.setAttribute('aria-label', variant.available ? variant.title : variant.title + ' (Sold out)');
        swatch.title = variant.title;
        swatch.disabled = !variant.available;
        if (variant.featured_image) {
          swatch.style.backgroundImage = 'url(' + variant.featured_image + ')';
        }
        if (String(variant.id) === String(defaultVariant.id)) {
          swatch.classList.add('is-selected');
          swatch.setAttribute('aria-selected', 'true');
        }

        swatch.addEventListener('click', function (e) {
          e.stopPropagation();
          swatchWrap.querySelectorAll('.pairs-well-modal__swatch').forEach(function (s) {
            s.classList.remove('is-selected');
            s.setAttribute('aria-selected', 'false');
          });
          swatch.classList.add('is-selected');
          swatch.setAttribute('aria-selected', 'true');
          swatchLabel.textContent = colorOptionLabel + ': ' + variant.title;
          updateForVariant(variant);
        });

        swatchWrap.appendChild(swatch);

        resolveConnectedProductImage(data, variant, function (imgUrl) {
          swatch.style.backgroundImage = 'url(' + imgUrl + ')';
        });
      });

      optionsWrap.appendChild(swatchWrap);
    } else if (hasMultipleVariants) {
      let select = document.createElement('select');
      select.className = 'pairs-well-modal__variant-select';
      select.setAttribute('aria-label', data.title + ' options');

      data.variants.forEach(function (variant) {
        let option = document.createElement('option');
        option.value = variant.id;
        option.textContent = variant.available ? variant.title : variant.title + ' (Sold out)';
        option.disabled = !variant.available;
        select.appendChild(option);
      });

      select.value = defaultVariant.id;
      select.addEventListener('change', function (e) {
        // Prevent Symmetry's own combined-listing swap script (which appears
        // to listen broadly for select "change" events) from reacting to
        // this dropdown as if it were the main product's option selector.
        e.stopPropagation();
        updateForVariant(findVariantById(select.value));
      });

      optionsWrap.appendChild(select);
    }

    updateForVariant(defaultVariant);

    addBtn.onclick = function () {
      let variantId = modal.dataset.variantId;
      if (!variantId) return;
      addBtn.disabled = true;
      message.textContent = 'Adding…';

      addToCart([{ id: Number(variantId), quantity: 1 }])
        .then(function () {
          message.textContent = data.title + ' added to cart.';
          refreshCartUI(addBtn);
          setTimeout(function () { modal.close(); }, 800);
        })
        .catch(function (err) {
          console.error(err);
          message.textContent = 'Something went wrong adding this to your cart.';
        })
        .finally(function () {
          addBtn.disabled = false;
        });
    };

    if (typeof modal.showModal === 'function') {
      modal.showModal();
    } else {
      modal.setAttribute('open', 'open');
    }
  }

  // ---------------------------------------------------------------
  // Carousel: prev/next buttons scroll the track, disabled at the ends
  // ---------------------------------------------------------------
  function setupCarousel(root) {
    let track = root.querySelector('[data-pairs-well-track]');
    let prevBtn = root.querySelector('[data-pairs-well-prev]');
    let nextBtn = root.querySelector('[data-pairs-well-next]');
    if (!track || !prevBtn || !nextBtn) return;

    function scrollAmount() {
      let firstItem = track.querySelector('[data-pairs-well-item]');
      let itemWidth = firstItem ? firstItem.getBoundingClientRect().width : track.clientWidth;
      let gap = 12;
      return itemWidth + gap;
    }

    function updateButtonState() {
      let isScrollable = track.scrollWidth > track.clientWidth + 1;
      prevBtn.style.display = isScrollable ? '' : 'none';
      nextBtn.style.display = isScrollable ? '' : 'none';

      let maxScroll = track.scrollWidth - track.clientWidth;
      prevBtn.disabled = track.scrollLeft <= 1;
      nextBtn.disabled = track.scrollLeft >= maxScroll - 1;
    }

    prevBtn.addEventListener('click', function () {
      track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', function () {
      track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
    });

    track.addEventListener('scroll', updateButtonState);
    window.addEventListener('resize', updateButtonState);

    updateButtonState();
  }


  function buildInlineVariantSelect(item, data) {
    let wrap = item.querySelector('[data-pairs-well-variant-select]');
    let checkbox = item.querySelector('[data-pairs-well-checkbox]');
    if (!wrap || !checkbox) return;

    if (!data.variants || data.variants.length <= 1) return;

    let select = document.createElement('select');
    select.className = 'pairs-well__inline-select';
    select.setAttribute('aria-label', data.title + ' options');

    select.addEventListener('click', function (e) {
      e.stopPropagation();
    });
    select.addEventListener('keydown', function (e) {
      e.stopPropagation();
    });

    data.variants.forEach(function (variant) {
      let option = document.createElement('option');
      option.value = variant.id;
      option.textContent = variant.available ? variant.title : variant.title + ' (Sold out)';
      option.disabled = !variant.available;
      select.appendChild(option);
    });

    // Default to the same variant the checkbox already carries
    // (rendered server-side via selected_or_first_available_variant)
    select.value = checkbox.dataset.variantId;

    let thumbnail = item.querySelector('.pairs-well__image');
    let priceEl = item.querySelector('.pairs-well__price');

    function applyVariantToCard(variant) {
      if (thumbnail && variant.featured_image && !isConnectedListingVariant(data, variant)) {
        thumbnail.src = variant.featured_image;
      }
      if (priceEl) {
        priceEl.textContent = variant.compare_at_price && variant.compare_at_price > variant.price
          ? formatMoney(variant.compare_at_price) + ' ' + formatMoney(variant.price)
          : formatMoney(variant.price);
      }

      resolveConnectedProductImage(data, variant, function (imgUrl) {
        if (thumbnail && select.value === String(variant.id)) {
          thumbnail.src = imgUrl;
        }
      });
    }

    select.addEventListener('change', function (e) {
      e.stopPropagation();
      let variant = data.variants.find(function (v) {
        return String(v.id) === select.value;
      });
      if (!variant) return;
      checkbox.dataset.variantId = variant.id;
      checkbox.disabled = !variant.available;
      if (!variant.available) checkbox.checked = false;
      applyVariantToCard(variant);
    });

    wrap.appendChild(select);

    let initialVariant = data.variants.find(function (v) {
      return String(v.id) === select.value;
    });
    if (initialVariant) applyVariantToCard(initialVariant);
  }

  function performBundledAdd(mainForm, pairsRoot, triggerEl) {
    let checked = pairsRoot.querySelectorAll('[data-pairs-well-checkbox]:checked');
    if (!checked.length) return false;

    let variantInput = mainForm.querySelector(VARIANT_INPUT_SELECTOR);
    let qtyInput = mainForm.querySelector(QUANTITY_INPUT_SELECTOR);
    let mainVariantId = variantInput ? Number(variantInput.value) : null;
    let mainQty = qtyInput ? Number(qtyInput.value) || 1 : 1;

    if (!mainVariantId) {
      console.error('[pairs-well-with] Could not read main product variant id from form. Check VARIANT_INPUT_SELECTOR.');
      return false;
    }

    let items = [{ id: mainVariantId, quantity: mainQty }];
    checked.forEach(function (box) {
      items.push({ id: Number(box.dataset.variantId), quantity: 1 });
    });

    if (triggerEl) triggerEl.disabled = true;

    addToCart(items)
      .then(function () {
        refreshCartUI(triggerEl);
      })
      .catch(function (err) {
        console.error('[pairs-well-with] Failed to add bundled items:', err);
      })
      .finally(function () {
        if (triggerEl) triggerEl.disabled = false;
      });

    return true;
  }

  // ---------------------------------------------------------------
  // Combined listings: each "variant" is really a separate connected
  // product with its own handle and its own real photo.
  // ---------------------------------------------------------------
  let connectedProductImageCache = {};

  function extractImageUrl(img) {
    if (!img) return null;
    if (typeof img === 'string') return img;
    if (img.src) return img.src;
    return null;
  }

  function isConnectedListingVariant(productData, variant) {
    if (!variant.url) return false;
    let variantPath = variant.url.split('?')[0];
    let productPath = (productData.url || '').split('?')[0];
    return Boolean(variantPath) && variantPath !== productPath;
  }

  function resolveConnectedProductImage(productData, variant, applyImage) {
    if (!isConnectedListingVariant(productData, variant)) return;
    let variantPath = variant.url.split('?')[0];

    if (!connectedProductImageCache[variantPath]) {
      connectedProductImageCache[variantPath] = fetch(variantPath + '.js', { credentials: 'same-origin' })
        .then(function (res) {
          if (!res.ok) throw new Error('Failed to fetch ' + variantPath + '.js (' + res.status + ')');
          return res.json();
        })
        .then(function (connectedProduct) {
          return (
            extractImageUrl(connectedProduct.featured_image) ||
            extractImageUrl(connectedProduct.image) ||
            (connectedProduct.images && extractImageUrl(connectedProduct.images[0])) ||
            null
          );
        })
        .catch(function (err) {
          console.error('[pairs-well-with] Could not fetch connected product image for ' + variantPath + ':', err);
          return null;
        });
    }

    connectedProductImageCache[variantPath].then(function (imgUrl) {
      if (imgUrl) applyImage(imgUrl);
    });
  }

  // ---------------------------------------------------------------
  // Shared cart helpers
  // ---------------------------------------------------------------
  function addToCart(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (res) {
      if (!res.ok) {
        return res.json().then(function (data) {
          throw new Error(data.description || 'Cart add failed');
        });
      }
      return res.json();
    });
  }

  function refreshCartUI(opener) {
    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
    document.dispatchEvent(
      new CustomEvent('dispatch:cart-drawer:open', {
        detail: { opener: opener || null }
      })
    );

    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      })
      .catch(function (err) {
        console.error('[pairs-well-with] Could not refresh cart count badge:', err);
      });
  }
})();